
import axios from "axios";
import { SERVER_URL } from "../config";



const request = axios.create({
  baseURL: SERVER_URL,
  timeout: 100000, // Adjust the timeout as needed
});

export const handleAddToken = (token) => {
  console.log("%c Line:13 🍊 token", "color:#42b983", token);
  request.interceptors.request.use(
    (config) => {
      config.headers.Authorization = "Bearer " + token;
      config.headers["host"] = "Bearer " +token;
      return config;
    },
    (error) => {
      console.log(error);
      return error;
    }
  );
};
export default request;




/* Analytics */
// Get Dashboard Analytics Data
// export const getAnalyticsList = (data) => {
//   return new Promise(async (resolve, reject) => {
//     await request
//       .get(`/order/sales/report`, { params: data })
//       .then((res) => {
//         resolve(res.data);
//       })
//       .catch((e) => {
//         reject(e);
//       });
//   });
// };


